import { render, staticRenderFns } from "./ProductFormTabDescription.vue?vue&type=template&id=769d3c58&scoped=true"
import script from "./ProductFormTabDescription.vue?vue&type=script&lang=js"
export * from "./ProductFormTabDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductFormTabDescription.vue?vue&type=style&index=0&id=769d3c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769d3c58",
  null
  
)

export default component.exports